import PropTypes from "prop-types";
import {StringInput, GenericReactForm, RadioCollectionInput,
        SelectCollectionInput, SubmitButton} from 'client/js/util/form_utils';
import StreetAndNumberInput from 'client/js/util/inputs/street_and_number_input';
import PostalAndCityInput from 'client/js/util/inputs/postal_and_city_input';
import {withLoading} from 'client/js/util/rest_utils';
import {FaIcon} from 'client/js/util/layout_utils';
import Modal from 'react-modal';
import ExternalLink from 'client/js/util/external_link';

const OrgInput = (props, context) => {
  if(context.formData && context.formData['role_type'] == 'ORG')
    return <StringInput {...props} />;

  return null;
}

OrgInput.contextTypes = {
  formData: PropTypes.object
};

const AbortButton = (props, context) => {
  return <button disabled={!!context.submitting} {...props} />
}

AbortButton.contextTypes = {
  submitting: PropTypes.bool
};

class HandleInput extends React.Component {
  state = {modal_open: false, working: false}

  handleAdd = (e) => {
    e.preventDefault();
    this.setState({modal_open: true});
  }

  handleAbort = (e) => {
    e.preventDefault();
    this.setState({modal_open: false});
  }

  formDispatch = (action) => {
    if(action == "form:success") {
      this.props.refreshCb();
      this.setState({modal_open: false});
    }
  }

  render() {
    const handleTypes = {"PERS": "Person oder Einzelunternehmer", "ORG": "Unternehmen, Verein oder Organisation"}
    const countries = [["DE","Germany"],["AT","Austria"],["CH","Switzerland"],["AF","Afghanistan"],["AL","Albania"],["DZ","Algeria"],["AS","American Samoa"],["AD","Andorra"],["AO","Angola"],["AI","Anguilla"],["AQ","Antarctica"],["AG","Antigua and Barbuda"],["AR","Argentina"],["AM","Armenia"],["AW","Aruba"],["AU","Australia"],["AZ","Azerbaijan"],["BS","Bahamas"],["BH","Bahrain"],["BD","Bangladesh"],["BB","Barbados"],["BY","Belarus"],["BE","Belgium"],["BZ","Belize"],["BJ","Benin"],["BM","Bermuda"],["BT","Bhutan"],["BO","Bolivia"],["BQ","Bonaire, Sint Eustatius and Saba"],["BA","Bosnia and Herzegovina"],["BW","Botswana"],["BV","Bouvet Island"],["BR","Brazil"],["IO","British Indian Ocean Territory"],["BN","Brunei Darussalam"],["BG","Bulgaria"],["BF","Burkina Faso"],["BI","Burundi"],["KH","Cambodia"],["CM","Cameroon"],["CA","Canada"],["CV","Cape Verde"],["KY","Cayman Islands"],["CF","Central African Republic"],["TD","Chad"],["CL","Chile"],["CN","China"],["CX","Christmas Island"],["CC","Cocos (Keeling) Islands"],["CO","Colombia"],["KM","Comoros"],["CG","Congo"],["CD","Congo, The Democratic Republic Of The"],["CK","Cook Islands"],["CR","Costa Rica"],["HR","Croatia"],["CU","Cuba"],["CW","Curaçao"],["CY","Cyprus"],["CZ","Czech Republic"],["CI","Côte D'Ivoire"],["DK","Denmark"],["DJ","Djibouti"],["DM","Dominica"],["DO","Dominican Republic"],["EC","Ecuador"],["EG","Egypt"],["SV","El Salvador"],["GQ","Equatorial Guinea"],["ER","Eritrea"],["EE","Estonia"],["ET","Ethiopia"],["FK","Falkland Islands (Malvinas)"],["FO","Faroe Islands"],["FJ","Fiji"],["FI","Finland"],["FR","France"],["GF","French Guiana"],["PF","French Polynesia"],["TF","French Southern Territories"],["GA","Gabon"],["GM","Gambia"],["GE","Georgia"],["GH","Ghana"],["GI","Gibraltar"],["GR","Greece"],["GL","Greenland"],["GD","Grenada"],["GP","Guadeloupe"],["GU","Guam"],["GT","Guatemala"],["GG","Guernsey"],["GN","Guinea"],["GW","Guinea-Bissau"],["GY","Guyana"],["HT","Haiti"],["HM","Heard and McDonald Islands"],["VA","Holy See (Vatican City State)"],["HN","Honduras"],["HK","Hong Kong"],["HU","Hungary"],["IS","Iceland"],["IN","India"],["ID","Indonesia"],["IR","Iran, Islamic Republic Of"],["IQ","Iraq"],["IE","Ireland"],["IM","Isle of Man"],["IL","Israel"],["IT","Italy"],["JM","Jamaica"],["JP","Japan"],["JE","Jersey"],["JO","Jordan"],["KZ","Kazakhstan"],["KE","Kenya"],["KI","Kiribati"],["KP","Korea, Democratic People's Republic Of"],["KR","Korea, Republic of"],["KW","Kuwait"],["KG","Kyrgyzstan"],["LA","Lao People's Democratic Republic"],["LV","Latvia"],["LB","Lebanon"],["LS","Lesotho"],["LR","Liberia"],["LY","Libya"],["LI","Liechtenstein"],["LT","Lithuania"],["LU","Luxembourg"],["MO","Macao"],["MK","Macedonia, the Former Yugoslav Republic Of"],["MG","Madagascar"],["MW","Malawi"],["MY","Malaysia"],["MV","Maldives"],["ML","Mali"],["MT","Malta"],["MH","Marshall Islands"],["MQ","Martinique"],["MR","Mauritania"],["MU","Mauritius"],["YT","Mayotte"],["MX","Mexico"],["FM","Micronesia, Federated States Of"],["MD","Moldova, Republic of"],["MC","Monaco"],["MN","Mongolia"],["ME","Montenegro"],["MS","Montserrat"],["MA","Morocco"],["MZ","Mozambique"],["MM","Myanmar"],["NA","Namibia"],["NR","Nauru"],["NP","Nepal"],["NL","Netherlands"],["AN","Netherlands Antilles"],["NC","New Caledonia"],["NZ","New Zealand"],["NI","Nicaragua"],["NE","Niger"],["NG","Nigeria"],["NU","Niue"],["NF","Norfolk Island"],["MP","Northern Mariana Islands"],["NO","Norway"],["OM","Oman"],["PK","Pakistan"],["PW","Palau"],["PS","Palestinian Territory, Occupied"],["PA","Panama"],["PG","Papua New Guinea"],["PY","Paraguay"],["PE","Peru"],["PH","Philippines"],["PN","Pitcairn"],["PL","Poland"],["PT","Portugal"],["PR","Puerto Rico"],["QA","Qatar"],["RO","Romania"],["RU","Russian Federation"],["RW","Rwanda"],["RE","Réunion"],["BL","Saint Barthélemy"],["SH","Saint Helena"],["KN","Saint Kitts And Nevis"],["LC","Saint Lucia"],["MF","Saint Martin"],["PM","Saint Pierre And Miquelon"],["VC","Saint Vincent And The Grenedines"],["WS","Samoa"],["SM","San Marino"],["ST","Sao Tome and Principe"],["SA","Saudi Arabia"],["SN","Senegal"],["RS","Serbia"],["SC","Seychelles"],["SL","Sierra Leone"],["SG","Singapore"],["SX","Sint Maarten"],["SK","Slovakia"],["SI","Slovenia"],["SB","Solomon Islands"],["SO","Somalia"],["ZA","South Africa"],["GS","South Georgia and the South Sandwich Islands"],["SS","South Sudan"],["ES","Spain"],["LK","Sri Lanka"],["SD","Sudan"],["SR","Suriname"],["SJ","Svalbard And Jan Mayen"],["SZ","Swaziland"],["SE","Sweden"],["SY","Syrian Arab Republic"],["TW","Taiwan, Republic Of China"],["TJ","Tajikistan"],["TZ","Tanzania, United Republic of"],["TH","Thailand"],["TL","Timor-Leste"],["TG","Togo"],["TK","Tokelau"],["TO","Tonga"],["TT","Trinidad and Tobago"],["TN","Tunisia"],["TR","Turkey"],["TM","Turkmenistan"],["TC","Turks and Caicos Islands"],["TV","Tuvalu"],["UG","Uganda"],["UA","Ukraine"],["AE","United Arab Emirates"],["GB","United Kingdom"],["US","United States"],["UM","United States Minor Outlying Islands"],["UY","Uruguay"],["UZ","Uzbekistan"],["VU","Vanuatu"],["VE","Venezuela, Bolivarian Republic of"],["VN","Vietnam"],["VG","Virgin Islands, British"],["VI","Virgin Islands, U.S."],["WF","Wallis and Futuna"],["EH","Western Sahara"],["YE","Yemen"],["ZM","Zambia"],["ZW","Zimbabwe"],["AX","Åland Islands"]];
    const resource_name = this.props.resource_name || this.props.label || this.props.input_label;

    const options = this.props.options ? this.props.options : this.props.data.handles.map((handle) => ({value: handle.id, label: handle.friendly_name}));

    return <>
        <SelectCollectionInput required name={this.props.name}
                               label={this.props.label || this.props.input_label}
                               disabled={this.props.disabled}
                               isLoading={this.props.isLoading}
                               hint={this.props.allowAddHandle ? <span><a href="#" onClick={this.handleAdd}><FaIcon name="plus" /> {resource_name} hinzufügen</a> {this.props.manage_link ? <ExternalLink href="/usercp/handles">{resource_name} verwalten</ExternalLink> : null}</span> : null}
                               raw_options={options} />

            <Modal isOpen={this.state.modal_open} className="modal fade in show d-block" contentLabel={`${resource_name} hinzufügen`}>
              <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h3>{resource_name} anlegen</h3>
                  <button type="button" className="close" onClick={this.handleAbort} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <GenericReactForm dispatch={this.formDispatch} defaults={this.props.handle_defaults} namespace="handle" url={this.props.create_handle_url}>
                  <div className="modal-body">
                    <RadioCollectionInput required name="role_type" label="Typ" options={handleTypes} />
                    <OrgInput name="organisation" label='Firma, Vereinsname' placeholder='Muster GmbH/e.V.' required />

                    <StringInput name="firstname" label="Vorname" required />
                    <StringInput name="lastname" label="Nachname" required />

                    <StreetAndNumberInput label="Straße und Hausnummer" />
                    <PostalAndCityInput label="Postleitzahl und Ort" />
                    <SelectCollectionInput name="country" label="Land" required options={countries} />

                    <StringInput name="email" label="E-Mail-Adresse" required />
                    <StringInput name="phone" label="Telefon" required type="tel" />
                    <StringInput name="fax" label="Fax" type="tel" />
                  </div>
                  <div className="modal-footer">
                    <SubmitButton className="btn btn-primary btn-lg" icon="plus" text={`${resource_name} anlegen`} />
                  </div>
                </GenericReactForm>
              </div>
              </div>
            </Modal>
      </>;
  }
}

HandleInput.propTypes = {
  name: PropTypes.string.isRequired,
  input_label: PropTypes.string.isRequired,
  resource_name: PropTypes.string.isRequired,
  manage_link: PropTypes.bool,
  handle_defaults: PropTypes.object,
  create_handle_url: PropTypes.string.isRequired
};

HandleInput.defaultProps = {
  handle_defaults: { role_type: 'PERS' },
  create_handle_url: '/usercp/handles'
};

const HandleInputContainer = withLoading(HandleInput);

const HandleWrapper = (props) => {
  if(props.reloadHandles) {
    //split props into handles, reloadHandles and pass the rest to the input
    const { handles, reloadHandles, ...otherProps } = props;

    return <HandleInput {...otherProps} data={{handles: handles || []}} refreshCb={reloadHandles} />;
  }

  return <HandleInputContainer {...props} />;
}

export default HandleWrapper;
